import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FilterMappingService } from 'src/app/services/results/filter-mapping.service';

export interface IFilterChip {
  label: string;
  value: any;
}

@Component({
  selector: 'app-filter-chips',
  templateUrl: './filter-chips.component.html',
  styleUrls: ['./filter-chips.component.scss']
})
export class FilterChipsComponent implements OnChanges {
  @Input() isEnterpriseWorkflow: boolean = false;
  @Input() formFactorFilters: string[] = [];
  @Input() screenSizeFilters: number[] = [];
  @Input() brandFilters: string[] = [];
  @Input() featureFilters: string[] = [];
  @Input() osTypeFilters: string[] = [];

  @Output() updateFormFactorFilter: EventEmitter<string> = new EventEmitter();
  @Output() updateScreenSizeFilter: EventEmitter<number[]> = new EventEmitter();
  @Output() updateBrandFilter: EventEmitter<string> = new EventEmitter();
  @Output() updateFeatureFilter: EventEmitter<string> = new EventEmitter();
  @Output() updateOsTypeFilter: EventEmitter<string> = new EventEmitter();

  formFactorFilterChips: IFilterChip[] = [];
  screenSizeFilterChips: IFilterChip[] = [];
  brandFilterChips: IFilterChip[] = [];
  featureFilterChips: IFilterChip[] = [];
  osTypeFilterChips: IFilterChip[] = [];

  constructor(public filterMapper: FilterMappingService) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.formFactorFilters) {
      this.formFactorFilterChips = changes.formFactorFilters.currentValue.map((filter: string) => ({ label: filter, value: filter }));
    }
    if (changes.screenSizeFilters) {
      this.screenSizeFilterChips = this.filterMapper.getScreenSizeFilterRanges(changes.screenSizeFilters.currentValue).map((range: number[]) => ({ label: this.filterMapper.getScreenSizeFilterLabel(range), value: range }));
    }
    if (changes.brandFilters) {
      this.brandFilterChips = changes.brandFilters.currentValue.map((filter: string) => ({ label: filter, value: filter }));
    }
    if (changes.featureFilters) {
      this.featureFilterChips = changes.featureFilters.currentValue.map((filter: string) => ({ label: this.filterMapper.getFeatureFilterLabel(filter), value: filter }));
    }
    if (changes.osTypeFilters) {
      this.osTypeFilterChips = changes.osTypeFilters.currentValue.map((filter: string) => ({ label: this.filterMapper.getOsTypeFilterLabel(filter), value: filter }));
    }
  }

  removeFormFactorFilter(filter: string): void {
    this.updateFormFactorFilter.emit(filter);
  }

  removeScreenSizeFilter(filter: number[]): void {
    this.updateScreenSizeFilter.emit(filter);
  }

  removeBrandFilter(filter: string): void {
    this.updateBrandFilter.emit(filter);
  }

  removeFeatureFilter(filter: string): void {
    this.updateFeatureFilter.emit(filter);
  }

  removeOsTypeFilter(filter: string): void {
    this.updateOsTypeFilter.emit(filter);
  }
}
